import { render } from "./settings-controllers-PeakShaving.vue?vue&type=template&id=827e39bc"
import script from "./settings-controllers-PeakShaving.vue?vue&type=script&lang=js"
export * from "./settings-controllers-PeakShaving.vue?vue&type=script&lang=js"

import "./settings-controllers-PeakShaving.vue?vue&type=style&index=0&id=827e39bc&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__